module.exports = __webpack_public_path__ + "img/cuco_banner_landing_mobile.3b3662fa.png";